import { useEffect, useMemo, useState } from 'react';
import api from '../api';

export default function AdminSubscriptions() {
  const [users, setUsers] = useState([]);
  const [services, setServices] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedService, setSelectedService] = useState('');
  const [selectedPackage, setSelectedPackage] = useState('');
  const [byUser, setByUser] = useState([]);
  const [byService, setByService] = useState([]);

  const loadBase = async () => {
    const u = await api.get('/users/list').then(r => r.data.items || []);
    setUsers(u);
    const s = await api.get('/services').then(r => r.data || []);
    setServices(s);
    const p = await api.get('/packages').then(r => r.data || []);
    setPackages(p);
  };
  useEffect(()=>{ loadBase(); }, []);

  const loadByUser = async (uid) => {
    if (!uid) { setByUser([]); return; }
    const res = await api.get(`/subscriptions/admin/by-user/${uid}`).then(r=>r.data.items||[]);
    setByUser(res);
  };
  const loadByService = async (sid) => {
    if (!sid) { setByService([]); return; }
    const res = await api.get(`/subscriptions/admin/by-service/${sid}`).then(r=>r.data.items||[]);
    setByService(res);
  };

  const assignService = async () => {
    if (!selectedUser || !selectedService) return;
    const bookedAt = new Date().toISOString();
    await api.post('/subscriptions/admin/assign', { userId: selectedUser, serviceId: selectedService, bookedAt });
    await loadByUser(selectedUser);
    await loadByService(selectedService);
  };
  const assignPackage = async () => {
    if (!selectedUser || !selectedPackage) return;
    const bookedAt = new Date().toISOString();
    await api.post('/subscriptions/admin/assign-package', { userId: selectedUser, packageId: selectedPackage, bookedAt });
    await loadByUser(selectedUser);
  };
  const removeRow = async (row) => {
    if (!confirm('Zuweisung löschen?')) return;
    await api.delete(`/subscriptions/admin/${row.id}`);
    await loadByUser(selectedUser);
    await loadByService(selectedService);
  };

  return (
    <div className="home-page">
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Dienstleistungen ↔ Mitglieder</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Zuweisungen verwalten, nach Mitglied oder Dienstleistung durchsuchen.</p>
      </section>
      <section style={{ width:'100%', maxWidth:1100, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
          <div>
            <div style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:12 }}>
              <h3 style={{ marginTop:0 }}>Nach Mitglied</h3>
              <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                <select value={selectedUser} onChange={e=>{ setSelectedUser(e.target.value); loadByUser(e.target.value); }}>
                  <option value="">Mitglied wählen…</option>
                  {users.map(u => <option key={u.id} value={u.id}>{u.displayName || u.username}</option>)}
                </select>
                <select value={selectedService} onChange={e=>{ setSelectedService(e.target.value); loadByService(e.target.value); }}>
                  <option value="">Dienstleistung wählen…</option>
                  {services.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
                <button onClick={assignService} disabled={!selectedUser || !selectedService}>Dienstleistung zuweisen</button>
              </div>
              <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', marginTop:8 }}>
                <select value={selectedPackage} onChange={e=>setSelectedPackage(e.target.value)}>
                  <option value="">Paket wählen…</option>
                  {packages.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
                <button onClick={assignPackage} disabled={!selectedUser || !selectedPackage}>Paket buchen (alle DL)</button>
              </div>
              <ul style={{ marginTop:12 }}>
                {byUser.map(r => (
                  <li key={r.id} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:8, marginBottom:8 }}>
                    <div>
                      <b>{r.Service?.name || '—'}</b>
                      {r.Package && <span style={{ fontSize:12, color:'#bbb' }}> · aus Paket: {r.Package.name}</span>}
                      <span style={{ fontSize:12, color:'#bbb' }}> · gebucht am {new Date(r.bookedAt).toLocaleDateString()}</span>
                    </div>
                    <div>
                      <button onClick={()=>removeRow(r)} style={{ color:'red' }}>Entfernen</button>
                    </div>
                  </li>
                ))}
                {selectedUser && byUser.length===0 && <li style={{ color:'#aaa' }}>Keine Zuweisungen für dieses Mitglied.</li>}
              </ul>
            </div>
          </div>
          <div>
            <div style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:12 }}>
              <h3 style={{ marginTop:0 }}>Nach Dienstleistung</h3>
              <div style={{ fontSize:12, color:'#bbb' }}>Mitglieder, die diese Dienstleistung gebucht haben.</div>
              <ul style={{ marginTop:12 }}>
                {byService.map(r => (
                  <li key={r.id} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:8, marginBottom:8 }}>
                    <div>
                      <b>{r.User?.displayName || r.User?.username || '—'}</b>
                      {r.Package && <span style={{ fontSize:12, color:'#bbb' }}> · via Paket: {r.Package.name}</span>}
                      <span style={{ fontSize:12, color:'#bbb' }}> · gebucht am {new Date(r.bookedAt).toLocaleDateString()}</span>
                    </div>
                    <div>
                      <button onClick={()=>removeRow(r)} style={{ color:'red' }}>Entfernen</button>
                    </div>
                  </li>
                ))}
                {selectedService && byService.length===0 && <li style={{ color:'#aaa' }}>Niemand hat diese Dienstleistung gebucht.</li>}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
